<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">{{ $t('menu.clients') }}</div>
      <v-spacer></v-spacer>
    </div>

    <v-flex xs12>
      <v-data-table
        loading-text="Cargando clientes"
        :server-items-length="table.total"
        :loading="table.loading"
        :headers="table.headers"
        :items="table.data"
        :options="table.options"
        sort-by="email"
        @update:options="updateTable"
        class="elevation-1 fixed-header">
        <template v-slot:item.restaurantCreditTimeLimit="{ item }">
          {{ item.restaurantCreditTimeLimit ? item.restaurantCreditTimeLimit + ' días': '-' }}
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex justify-end align-center">
            <v-tooltip  left>
              <template
                v-slot:activator="{ on }">
                <v-btn
                  fab
                  x-small
                  depressed
                  color="info"
                  class="mr-2"
                  v-on="on"
                  @click="onOpenCreateOrUpdateUserDialog(item)">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>Crear plazo de crédito</span>
            </v-tooltip>
            <v-tooltip left>
              <template
                v-slot:activator="{ on }">
                <v-btn
                  fab
                  x-small
                  depressed
                  color="error"
                  v-on="on"
                  @click="onOpenRemoveUserDialog(item)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Eliminar plazo de crédito</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </v-flex>

    <v-dialog @keydown.esc="createDialog=false" v-model="createDialog" persistent max-width="350px">
      <v-card class="py-2">
        <v-card-title>
          <span class="headline">¿Crear plazo de crédito?</span>
        </v-card-title>
        <v-card-text>
          <div class="d-flex justify-space-between subtitle-1">
            A la hora dar de alta un plazo de crédito, todas las ordenes de compra que se lleguén a generar por medio de este restaurante tendrán un crédito de un plazo de días partiendo de la fecha en la que se entrega la órden de compra.
          </div>
        </v-card-text>
        <v-card-text class="mr-04">
          <v-form ref="createOrUpdate" v-model="form.valid">
            <v-row>
              <v-col>
                <v-flex md12>
                  <v-text-field
                    v-model.number="form.data.restaurantCreditTimeLimit"
                    label="Ingresa el plazo del crédito en días hábiles"
                    type="number"
                    dense
                    outlined
                    rounded
                    required>
                  </v-text-field>
                </v-flex>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black darken-1" text @click="onCloseCreateDialog">Cerrar</v-btn>
          <v-btn color="black darken-1" text @click="submit(form.data)">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog @keydown.esc="removeDialog=false" v-model="removeDialog" persistent max-width="300px">
      <v-card>
        <v-card-title>
          <span class="headline">¿Deseas borrar el plazo de crédito?</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black darken-1" text @click="onCloseRemoveDialog">Cerrar</v-btn>
          <v-btn color="black darken-1" text @click="remove(form.data)">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="999999999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-layout>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'Clientes',
  data () {
    return {
      createDialog: false,
      removeDialog: false,
      overlay: false,
      table: {
        title: 'Cargando clientes',
        loading: true,
        headers: [
          { text: 'Restaurante', value: 'restaurant.name' },
          { text: 'Fecha de plazo', value: 'restaurantCreditTimeLimit', sortable: false },
          { text: 'Actions', value: 'action', sortable: false }
        ],
        data: [],
        total: 0,
        options: {
          itemsPerPage: 15,
          page: 1
        }
      },
      form: {
        valid: false,
        data: {
          restaurant: null,
          restaurantCreditTimeLimit: null
        }
      }
    }
  },
  computed: {
    provider () { return this.$store.state.currentProvider.data }
  },
  methods: {
    updateTable: async function (data) {
      this.table.options = data
      const params = {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1))
      }
      try {
        await this.load(params)
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
    },
    async load (params = null) {
      params = params || {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.page - 1))
      }
      try {
        const response = await this.$api.get(`/v1/providers/${this.provider._id}/customer-credit`, params)
        this.table.loading = false
        this.table.data = response.data
        this.table.total = response.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
    },
    onCloseCreateDialog: function () {
      this.form.data = {}
      this.createDialog = false
    },
    onOpenCreateOrUpdateUserDialog: function (data) {
      const cloneData = cloneDeep(data)
      this.form.data = cloneData
      this.createDialog = true
    },
    onOpenRemoveUserDialog: function (data) {
      this.form.data = cloneDeep(data)
      this.removeDialog = true
    },
    onCloseRemoveDialog: function () {
      this.onCloseCreateDialog()
      this.removeDialog = false
    },
    submit: async function (data) {
      this.overlay = true
      try {
        await this.$api.put(`/v1/providers/${this.provider._id}/customer-credit/${data.restaurant._id}`, { restaurantCreditTimeLimit: this.form.data.restaurantCreditTimeLimit })
        await this.updateTable(this.table.options)
        this.onCloseCreateDialog()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    remove: async function (data) {
      this.overlay = true
      try {
        await this.$api.del(`/v1/providers/${this.provider._id}/customer-credit/${data.restaurant._id}`)
        await this.updateTable(this.table.options)
        this.onCloseRemoveDialog()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    }
  }
}
</script>

<style lang="css" scoped>
</style>
